import { ConfigurationType } from './types';
import { ConfigurationItem } from './DependenciesTypes';
import { DependenciesSideDialogContent } from './DependenciesSideDialogContent';
import { ResizablePanelWrapper } from './ResizablePanelWrapper';
import { useExpandedMode } from '../../pages/configuration-canvas/panels-reserve-space/useExpandedMode';
import { AddToCanvasButton } from '../../pages/funnel-map-flow/dialogs/metadata-elements/AddToCanvasButton';
import { isMetadataElementInCanvas } from '../../pages/funnel-map-flow/dialogs/metadata-elements/helper';
import { SWEEP_ELEMENTS } from './helpers';
import { useDocumentationContext } from '../context/DocumentationContext';
import { UI_EVENTS } from '../../../services/events';

interface DependenciesSideDialogProps {
  crmOrgId: string;
  configurationItem: ConfigurationItem;
  type: ConfigurationType;
  staticView?: boolean;
  onCloseDocumentationDialog?: () => void;
}

export const DependenciesSideDialog = ({
  crmOrgId,
  configurationItem,
  type,
  staticView,
  onCloseDocumentationDialog,
}: DependenciesSideDialogProps) => {
  const isSweepElement = SWEEP_ELEMENTS.includes(type);
  const { isExpandedMode } = useExpandedMode();
  const { canvasFunnelMap } = useDocumentationContext();

  const isInCanvas = canvasFunnelMap
    ? isMetadataElementInCanvas({
        crmOrgId,
        metadataId: configurationItem?.metadataId ?? '',
        canvasFunnelMap,
      })
    : false;

  return (
    <ResizablePanelWrapper
      crmOrgId={crmOrgId}
      configurationItemId={configurationItem.id}
      staticView={staticView}
    >
      <DependenciesSideDialogContent
        crmOrgId={crmOrgId}
        configurationItem={configurationItem}
        type={type}
        headerContent={
          isExpandedMode ||
          !canvasFunnelMap ||
          isSweepElement ||
          !configurationItem.metadataId ? null : (
            <AddToCanvasButton
              isStaticView={true}
              isInCanvas={isInCanvas}
              element={configurationItem}
              callback={onCloseDocumentationDialog}
              crmOrgId={crmOrgId}
              biEventName={UI_EVENTS.documentationAddMetadataToCanvas}
            />
          )
        }
      />
    </ResizablePanelWrapper>
  );
};
